/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClockInPortal } from './ClockInPortal';
import {
    ClockInPortalFromJSON,
    ClockInPortalFromJSONTyped,
    ClockInPortalToJSON,
    ClockInPortalToJSONTyped,
} from './ClockInPortal';

/**
 * 
 * @export
 * @interface CreateClockInPortalResponse
 */
export interface CreateClockInPortalResponse {
    /**
     * 
     * @type {ClockInPortal}
     * @memberof CreateClockInPortalResponse
     */
    data: ClockInPortal;
}

/**
 * Check if a given object implements the CreateClockInPortalResponse interface.
 */
export function instanceOfCreateClockInPortalResponse(value: object): value is CreateClockInPortalResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateClockInPortalResponseFromJSON(json: any): CreateClockInPortalResponse {
    return CreateClockInPortalResponseFromJSONTyped(json, false);
}

export function CreateClockInPortalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClockInPortalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ClockInPortalFromJSON(json['data']),
    };
}

  export function CreateClockInPortalResponseToJSON(json: any): CreateClockInPortalResponse {
      return CreateClockInPortalResponseToJSONTyped(json, false);
  }

  export function CreateClockInPortalResponseToJSONTyped(value?: CreateClockInPortalResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ClockInPortalToJSON(value['data']),
    };
}

